import * as Haptics from 'expo-haptics'
import { Platform } from 'react-native'

export const vibrateSuccess =
  Platform.OS === 'web'
    ? () => typeof navigator.vibrate === 'function' && navigator.vibrate(200)
    : () => Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success)

export const vibrateError =
  Platform.OS === 'web'
    ? () => typeof navigator.vibrate === 'function' && navigator.vibrate(400)
    : () => Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error)
